const CompOffReportTypes = {
	GET_ALL_COMPOFF_BY_ORG_START: 'get_all_compoff_by_org_start',
	GET_ALL_COMPOFF_BY_ORG_SUCCESS: 'get_all_compoff_by_org_success',
	GET_ALL_COMPOFF_BY_ORG_FAILURE: 'get_all_compoff_by_org_failure',
	GET_ALL_COMPOFF_BY_ORG_RESET: 'get_all_compoff_by_org_reset',
	GET_ALL_COMPOFF_BY_ORG_KEY: 'GetAllCompOffByOrgFromWeb',
};

export default CompOffReportTypes;

